import gql from 'graphql-tag';

export const getArticlesByCategoryQuery = gql`
  query ($categories: [String], $limit: Int = 1000, $isPreview: Boolean = false) {
    supportArticleCollection(
      where: { categories_contains_some: $categories }
      limit: $limit
      order: [promoted_DESC, title_ASC]
      preview: $isPreview
    ) {
      items {
        sys {
          id
        }
        title
        metaPageSlug
        categories
        metaPageSlug
        promoted
      }
    }
  }
`;
